import React, { useMemo } from "react";
import { WalletProvider } from "@solana/wallet-adapter-react";
import type { Adapter } from "@solana/wallet-adapter-base";

// // // //

/**
 * SolanaWalletProvider
 * App-wide wallet context so both the asset order card and the navbar
 * wallet chip share one connection. Wallet-standard wallets (Phantom,
 * Solflare, Backpack, …) register themselves automatically, so no explicit
 * adapters are listed — this keeps the global bundle cost minimal (no
 * web3.js; that loads only with the order card).
 * autoConnect reconnects the last-used wallet cached by the adapter.
 */
export function SolanaWalletProvider(props: { children: React.ReactNode }) {
    const wallets = useMemo<Adapter[]>(() => [], []);

    return (
        <WalletProvider wallets={wallets} autoConnect>
            {props.children}
        </WalletProvider>
    );
}
